import React from 'react'
import PropTypes from 'prop-types'
import PreviewBannerComponent from '../../components/PreviewBanner'
import usePreviewMode from '../../hooks/usePreviewMode'

function PreviewBanner({ url, ...props }) {
  const { isPreviewMode, onDeactivateClick } = usePreviewMode(url)

  return isPreviewMode ? <PreviewBannerComponent {...props} onClick={onDeactivateClick} /> : null
}

PreviewBanner.propTypes = {
  url: PropTypes.string,
}

export default PreviewBanner
